const NoDocuments = () => {
  return (
    <svg viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Back document */}
      <rect x="30" y="14" width="52" height="66" rx="5" fill="#e6f0f8" stroke="#14508c" strokeWidth="1.5" />

      {/* Front document */}
      <rect x="22" y="22" width="52" height="66" rx="5" fill="#e6f7f7" stroke="#0f6b6b" strokeWidth="1.5" />

      {/* Folded corner */}
      <path d="M58 22 L74 22 L74 36 Z" fill="#c8e8e8" stroke="#0f6b6b" strokeWidth="1.2" strokeLinejoin="round" />

      {/* Text lines */}
      <rect x="30" y="42" width="30" height="3.5" rx="1.75" fill="#0f6b6b" opacity="0.35" />
      <rect x="30" y="50" width="36" height="3" rx="1.5" fill="#0f6b6b" opacity="0.2" />
      <rect x="30" y="57" width="28" height="3" rx="1.5" fill="#0f6b6b" opacity="0.2" />
      <rect x="30" y="64" width="32" height="3" rx="1.5" fill="#0f6b6b" opacity="0.2" />

      {/* Magnifier */}
      <circle cx="82" cy="72" r="10" fill="#e6f0f8" stroke="#14508c" strokeWidth="1.8" />
      <line x1="89" y1="79" x2="96" y2="86" stroke="#14508c" strokeWidth="2.2" strokeLinecap="round" />
      <line x1="78" y1="72" x2="86" y2="72" stroke="#14508c" strokeWidth="1.4" strokeLinecap="round" opacity="0.5" />
      <line x1="82" y1="68" x2="82" y2="76" stroke="#14508c" strokeWidth="1.4" strokeLinecap="round" opacity="0.5" />
    </svg>
  );
};

export default NoDocuments;
